import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ProgressBarController extends Controller {
  static values = {
    currentCount: { type: Number },
    totalCount: { type: Number }
  }

  static targets = ['waypoint']

  connect () {
    this.#setCurrentValue()
  }

  reconnect () {
    this.#setCurrentValue()
  }

  #setCurrentValue () {
    const progress = (this.currentCountValue / this.totalCountValue) * 100

    this.waypointTarget.style.width = `${progress}%`
    return this.waypointTarget.style.width
  }
}

stimulus.register('progress-bar', ProgressBarController)
